import { omit } from 'lodash';
import { EcommerceProductModel } from '@/helpers/entities/models/EcommerceProductModel';
import { isNotEmpty } from '@/helpers';
export class CartPromoModel {
    constructor(payload) {
        const params = omit(payload, ['products']);
        Object.assign(this, params);
        const node = (product) => {
            return new EcommerceProductModel(product.node);
        };
        this.products = payload.products.edges.map(node);
        this.paymentOptions = payload.applicablePaymentOption;
    }
    get firstProductFreebieName() {
        if (this.products && isNotEmpty(this.products.length)) {
            return this.products[0].name;
        }
        return null;
    }
}
